// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";

import ImageHelper from "app/util/ImageHelper";

import type { Props } from "app/components/TimelineCard/TimelineCard";
import ShortComment from "app/components/ShortComment/ShortComment";
import TimelineItemOverlay from "app/components/TimelineItemOverlay/TimelineItemOverlay";

import "./ImageTimelineCard.scss";

@observer
export default class ImageTimelineCard extends React.Component<Props> {
    get url(): string {
        return ImageHelper.makeUrl(this.props.item.image);
    }

    get length(): number {
        return AppearanceStore.timelineContentLength;
    }

    handleReadMore = () => {
        this.props.onExpand();
    }

    render() {
        if (
            (AppearanceStore.isMobile || AppearanceStore.embed) &&
            !this.props.isExpanded
        ) {
            return this.renderVerticalViewShrunk();
        } else {
            return this.renderOther();
        }
    }

    renderVerticalViewShrunk() {
        const item = this.props.item;
        const hasText = item.metaTitle || item.metaDescription || item.comment.length > 0;
        const imageContainerClass = hasText 
            ? "TimelineCard--linkable__imageContainer"
            : "TimelineCard--linkable__imageContainer_notext";

        return (
            <div className="ImageTimelineCard">
                {this.renderOverlay()}
                <div onClick={this.props.onExpand}>
                    <div className="TimelineCard--linkable">
                        <div className="TimelineCard--linkable__container">
                            <div className={imageContainerClass}>
                                <img
                                    className="TimelineCard--linkable__image"
                                    src={this.url}
                                    alt="Timeline item"
                                    onClick={this.props.onExpand}
                                />
                            </div>
                            {hasText &&
                                <div className="TimelineCard--linkable__titleAndDescriptionContainer">
                                    {item.metaTitle && (
                                        <div className="TimelineCard--linkable__title">
                                            {item.metaTitle}
                                        </div>
                                    )}

                                    {item.metaDescription && (
                                        <div className="TimelineCard--linkable__description">
                                            {item.metaDescription}
                                        </div>
                                    )}

                                    <ShortComment
                                        itemId={item.rowid}
                                        comment={item.comment}
                                        length={this.length}
                                        onReadMore={this.handleReadMore}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderOther() {
        const item = this.props.item;
        const classes = ["ImageTimelineCard"];
        if (this.props.isExpanded) {
            classes.push("ImageTimelineCard--expanded");
        }

        return (
            <div className={classes.join(" ")}>
                <ShortComment
                    itemId={item.rowid}
                    comment={item.comment}
                    length={this.length}
                    key={item.rowid}
                />
                <img
                    src={this.url}
                    alt="Timeline item"
                    onClick={this.props.onExpand}
                />
            </div>
        );
    }

    renderOverlay() {
        return (
            <TimelineItemOverlay
                {...this.props}
                onClose={this.props.onUnExpand}
                overlayVisible={this.props.isExpanded}
            >
                <img src={this.url} alt="Timeline item" />
            </TimelineItemOverlay>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCard/ImageTimelineCard/ImageTimelineCard.js